import React, { useEffect, useRef, useState } from 'react'

import KanbanBoardContext from 'contexts/KanbanBoardContext'

import useFetch from 'hooks/useFetch'
import usePermissions from 'hooks/usePermissions'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import constants from 'constants/index'

const KanbanBoardProvider = ({ children }) => {
  const snackbar = useSnackbar()
  const permissions = usePermissions()
  const canFinalize = permissions.permitted(
    constants.permissions.KANBAN_TASKS.FINALIZE,
  )
  const canDragColumn = permissions.permitted(
    constants.permissions.KANBAN_TASKS.MANAGE_COLUMNS,
  )

  const [columns, setColumns] = useState([])
  const [boardId, setBoardId] = useState(null)
  const [isBoardLoading, setIsBoardLoading] = useState(false)

  const [manageColumnsOpen, setManageColumnsOpen] = useState(false)
  const columnChangedRef = useRef(false)

  useEffect(() => {
    const init = async () => {
      setIsBoardLoading(true)
      try {
        const res = await service.dponet.kanbanBoards.get()
        const boards = res?.data?.kanbanBoards || []
        const board = boards.find((b) => b.isDefault) || boards[0]
        if (board) setBoardId(board.id)
      } catch {
        snackbar.open({ message: 'Erro ao carregar board', variant: 'error' })
      } finally {
        setIsBoardLoading(false)
      }
    }
    init()
    //eslint-disable-next-line
  }, [])

  const {
    response: columnsResponse,
    isLoading: columnsLoading,
    refresh: refreshColumns,
  } = useFetch(
    service.dponet.kanbanColumns.get,
    { kanbanBoardId: boardId },
    [boardId],
    boardId !== null,
  )

  useEffect(() => {
    const newColumns = columnsResponse?.data?.kanbanColumns
    if (newColumns) setColumns(newColumns)
  }, [columnsResponse])

  const handleSaveColumns = (updatedColumns) => {
    setColumns(updatedColumns)
    columnChangedRef.current = true
  }

  const handleCloseColumnModal = (open) => {
    setManageColumnsOpen(open)
    if (!open && columnChangedRef.current) {
      refreshColumns()
      columnChangedRef.current = false
    }
  }

  return (
    <KanbanBoardContext.Provider
      value={{
        boardId,
        columns,
        columnsLoading,
        isBoardLoading,
        setColumns,
        refreshColumns,
        handleSaveColumns,
        handleCloseColumnModal,
        manageColumnsOpen,
        canDragColumn,
        canFinalize,
      }}
    >
      {children}
    </KanbanBoardContext.Provider>
  )
}

export default KanbanBoardProvider
